import react, { useEffect, useState } from 'react'
import styled from 'styled-components'
import UserBox from '../../Common/UserBox'
import MentorBox from '../../Common/MentorBox'
import JobTestBox from '../../Common/JobTestBox'
import { FriendToUser } from '../../../models/FriendToUser'
import { SelectedProps } from '../../Layout/CommonStyle'
import { Link } from 'react-router-dom'

type Props = {
  friends: FriendToUser[]
  friend: FriendToUser | undefined
  setFriend: (friend: FriendToUser) => void
}

function LeftSide(props: Props) {
  const [selected, setSelected] = useState<number>(-1)
  const [friends, setFriends] = useState<FriendToUser[]>(props.friends)
  const [count, setCount] = useState(0)

  useEffect(() => {
    let f = [...props.friends]
    if (f.length > 1) {
      f = f.sort((a, b) => {
        return a.friend.username.localeCompare(b.friend.username)
      })
    }
    setFriends(f)
    setSelected(f.findIndex((f) => f.friend.id === props.friend?.friend.id))
  }, [props.friends, props.friend])

  return (
    <Container>
      <Title>
        친구목록 ({props.friends && <span>{props.friends.length}</span>})
      </Title>
      <Content>
        <>
          {friends &&
            friends.length > 0 &&
            friends.map((friend: FriendToUser, index: number) => (
              <Link to={`/mentee/friend/${friend.friend.id}`} key={index}>
                <Line
                  key={index}
                  selected={index === selected ? 'selected' : ''}
                >
                  {friend.friend.username}
                </Line>
              </Link>
            ))}
        </>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  grid-area: leftside;
`
const Title = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
`
const Content = styled.div`
  max-height: 700px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #f0f0f0;
  }
  &::-webkit-scrollbar-track {
    background-color: white;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`
const Line = styled.div`
  //width: 80%;
  font-size: 1rem;
  text-align: center;
  vertical-align: middle;
  padding: 10px 20px;
  cursor: pointer;
  background-color: ${(props: SelectedProps) =>
    props.selected === 'selected' ? 'orange' : 'white'};

  &:hover {
    background-color: ${(props: SelectedProps) =>
      props.selected === 'selected' ? 'orange' : 'aliceblue'};
  }
`

export default LeftSide
